import React, { useEffect, useState } from 'react';
import { get, slice } from 'lodash';

import api from '../../actions/api';
import { formatDotNetDate } from '../Utils';

import footerLogo from '../../assets/footer_logo.svg';
import twitterLogo from '../../assets/twitter.svg';
import envelopeLogo from '../../assets/envelope.svg';
import buildingLogo from '../../assets/building.svg';

import style from './style.module.css';

const DEFAULT_BLOG_CONTENT_API_KEY = '300915c06a321879431f000a0d';

const Footer = ({ onMenuClick }) => {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        const blogApiKey = process.env.REACT_APP_BLOG_KEY || DEFAULT_BLOG_CONTENT_API_KEY;

        api.get(`/content/posts/?key=${blogApiKey}&limit=3&fields=title,url,published_at`)
            .then(function (response) {
                const blogPosts = get(response, 'data.posts', []);
                setPosts(slice(blogPosts, 0, 3));
            })
            .catch(function () {
                setPosts([]);
            });
    }, []);
    return (
        <div className={`${style.footer}`}>
            <div className={`${style.c}`}>
                <div className={`${style.items}`}>
                    <div className={`${style.item} ${style.logo}`}>
                        <a onClick={() => onMenuClick("banner")}><img src={footerLogo} /></a>
                        <div className={`${style.socialIcons}`}>
                            <a className={`${style.sItems} ${style.commonLink}`} href="https://x.com/outstandly" target="_blank"><img src={twitterLogo} /></a>
                        </div>
                    </div>
                    <div className={`${style.item} ${style.blog}`}>
                        <div className={`${style.menuTitle}`}>Latest Blog Posts</div>
                        <div className={`${style.blogItems}`}>
                            {posts && posts.length > 0 && posts.map((postItem, i) => {
                                return (
                                    <a className={`${style.blogItem} ${style.commonLink}`} href={get(postItem, 'url')} target="_blank" key={i}>
                                        <div>{get(postItem, 'title')}</div>
                                        <div className={`${style.publishedAt}`}>{get(postItem, 'published_at') && formatDotNetDate(get(postItem, 'published_at'))}</div>
                                    </a>
                                )
                            })}
                        </div>
                    </div>
                    <div className={`${style.item} ${style.privacyLinks}`}>
                        <div className={`${style.menuTitle}`}>If Bored</div>
                        <div className={`${style.menuItems}`}>
                            <div className={`${style.menuItem} ${style.commonLink}`}>
                                <a href={`${process.env.PUBLIC_URL || ''}/cookie-policy/`} title="Cookie Policy">Cookie Policy</a>
                            </div>
                            <div className={`${style.menuItem} ${style.commonLink}`}>
                                <a href={`${process.env.PUBLIC_URL || ''}/privacy/`} title="Privacy Policy">Privacy Policy</a>
                            </div>
                            <div className={`${style.menuItem} ${style.commonLink}`}>
                                <a href={`${process.env.PUBLIC_URL || ''}/terms/`} title="Terms and Conditions">Terms and Conditions</a>
                            </div>
                        </div>
                    </div>
                    <div className={`${style.item} ${style.contactLinks}`}>
                        <div className={`${style.menuTitle}`}>Contact Us</div>
                        <div className={`${style.detail}`}>
                            <div className={`${style.email}`}>
                                <a className={`${style.commonLink}`} href="mailto:cellardoor@outstandly.com"><span><img src={envelopeLogo} /></span><span>cellardoor@outstandly.com</span></a>
                            </div>
                            <div className={`${style.address}`}>
                                <span><img src={buildingLogo} /></span><span>Your love letters are accepted at:<br />Outstandly Ventures Ltd,<br />86-90 Paul Street,<br />London EC2A 4NE</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${style.copyrightsBorder}`}></div>
                <div className={`${style.copyrights}`}>
                    <div className={`${style.companyNumber}`}>Company number: 14135954</div>
                    <div className={`${style.rights}`}>© Outstandly Ventures Ltd {(new Date().getFullYear())} | All Rights Reserved</div>
                </div>
            </div>
        </div>
    )
}

export default Footer;
